"use client";

import { dlCtaTextConstants, dlEventConstants } from "@repo/analytics/data-layer.constants";
import { dataLayer } from "@repo/analytics/data-layer-utils";

export interface IArrowBtnDl {
  component?: string;
  event?: string;
  section_title?: string;
  cta_text?: string;
  event_type?: string;
  element?: string;
  tag1?: string;
}

/**
 * Track carousel arrow clicks (prev/next).
 */
export function trackArrowClick(
  componentName: string,
  direction: "left" | "right",
  moduleName: string,
  sectionName: string
): void {
  const ctaText =
    direction === "left"
      ? dlCtaTextConstants.LEFT_ARROW
      : dlCtaTextConstants.RIGHT_ARROW;

  const arrowData: IArrowBtnDl = {
    component: componentName,
    event: dlEventConstants.CLICK,
    event_type: dlEventConstants.ICON_CLICK,
    section_title: sectionName,
    cta_text: ctaText,
    element: `${componentName.toLowerCase().replace(/_/g, "_")}_icon_click`,
    ...(moduleName !== undefined ? { tag1: moduleName } : {}),
  };

  dataLayer("", arrowData, { isBannerComponent: "true" });
}
